import { render, staticRenderFns } from "./InstrumentUltimateTzGovernment.vue?vue&type=template&id=4a580c0d&"
import script from "./InstrumentUltimateTzGovernment.vue?vue&type=script&lang=js&"
export * from "./InstrumentUltimateTzGovernment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports